import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import {
  View,
  ScrollView,
  TouchableWithoutFeedback,
  Animated,
} from "react-native";
import { Feather, AntDesign, MaterialCommunityIcons } from "@expo/vector-icons";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import richTextHelpers from "app/utils/richTextHelpers";
import clipboardHelpers from "app/utils/clipboardHelpers";
import valueActions from "app/utils/valueActions";
import chapterActions from "app/utils/chapterActions";
import momentActions from "app/utils/momentActions";

import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import RichText from "app/components/RichText";
import RichTextArea from "app/components/RichTextArea";
import TextInput from "app/components/TextInput";
import Autocomplete from "app/components/Autocomplete";
import MultiButton from "app/components/MultiButton";
import Hoverable from "app/components/Hoverable";

import { StyleContext } from "app/contexts/Style";
import JournalChatPanel from "app/components/JournalChatPanel";

let USE_RTA = false;
USE_RTA = true;

let DEPRECATE_NOTES_FOR_TITLE_ONLY = false;

export default class ScratchPad extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    let text = "";
    let updateValueTitle = false;
    if (!!props.value?.id) {
      if (
        DEPRECATE_NOTES_FOR_TITLE_ONLY &&
        !props.value.text?.length &&
        !!props.value.title?.length
      ) {
        updateValueTitle = true;
        text = props.value.title;
      } else {
        text = props.value.text;
      }
    } else {
      text = props.chapter?.text || "";
    }
    let snapshot = null;
    let nextSnapshot = null;
    if (!!props.moment?.snapshot) {
      snapshot = JSON.parse(props.moment.snapshot);
    }
    if (!!props.moment?.next_snapshot) {
      nextSnapshot = JSON.parse(props.moment.next_snapshot);
    }
    this.state = {
      updateValueTitle,
      editing: false,
      text,
      initialText: text,
      query: "",
      selection: null,
      isDirty: false,
      showActions: !props.inline,
      showActions: false,
      snapshot,
      nextSnapshot,
      expanded: true,
      showJournalChat: false,
      knownUpdatedAt: props.value?.updated_at || null,
    };
    this.clipboardToastAnim = new Animated.Value(0);
  }

  componentDidMount() {
    if (this.props.inline) return;
    if (ENV.WEB) {
      document.addEventListener("keyup", this.handleKeyUp);
    }
  }

  componentWillUnmount() {
    if (ENV.WEB) {
      document.removeEventListener("keyup", this.handleKeyUp);
    }
  }

  handleKeyUp = (e) => {
    return;
    if (document.activeElement.id == "body") {
      let ignoreKeys = ["Tab"];
      let key = e.nativeEvent?.key || e.key;
      if (
        String.fromCharCode(e.keyCode).match(/(\w|\s)/g) &&
        !ignoreKeys.includes(key)
      ) {
        this.rtaRef?.focus();
      }
    }
  };

  focus = (pos = 0) => {
    try {
      this.rtaRef?.focus(pos);
    } catch (e) {
      console.warn("scratchpad focus fail", e);
    }
  };

  render() {
    let { value, chapter, inline, numberOfLines, maxWidth, expandable } =
      this.props;
    let {
      text,
      editing,
      selection,
      query,
      isDirty,
      snapshot,
      nextSnapshot,
      expanded,
      showJournalChat,
    } = this.state;

    return (
      <Hoverable>
        {(isHovered) => (
          <View>
            <View
              style={[
                this.styles().wrapper,
                inline && this.styles().inlineWrapper,
                maxWidth && { maxWidth },
              ]}
            >
              {isHovered && (
                <View
                  style={{
                    position: "absolute",
                    right: this.context.sizes.large,
                    zIndex: 2,
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                ></View>
              )}

              {USE_RTA ? (
                <View
                  style={{
                    zIndex: 2,
                    // backgroundColor: this.context.colors.highlight,
                    backgroundColor: colorHelpers.hexToRgbaString(
                      this.context.colors.trim,
                      0.2,
                    ),
                  }}
                >
                  <RichTextArea
                    text={text || ""}
                    snapshotText={!!snapshot ? snapshot?.text || "" : undefined}
                    nextSnapshotText={
                      !!nextSnapshot ? nextSnapshot?.text || "" : undefined
                    }
                    placeholder={this.props.placeholder || "Add a note..."}
                    value={value}
                    chapter={chapter}
                    references={value?.references || this.props.references}
                    ref={(r) => (this.rtaRef = r)}
                    momentBulletRefs
                    defaultFocus={!inline}
                    readOnly={this.props.readOnly}
                    onFocus={() => {
                      this.setState({ editing: true });
                      this.props.onFocus && this.props.onFocus();
                    }}
                    onChangeText={(text) => {
                      this.setState({ text, isDirty: true });
                      this.handleChangeText();
                      this.applySelection();
                    }}
                    // onMouseUp={(e, selection) => {
                    //   this.applySelection(selection);
                    // }}
                    // setSelection={(selection) => this.setState({selection})}
                    onStopEditing={() => {
                      this.stopEditing();
                      this.applySelection();
                    }}
                    // lets a hosting bullet (e.g. the tarot item) dismiss on
                    // escape from within the scratchpad
                    onEscape={this.props.onEscape}
                    composeMoment={
                      !!value?.id
                        ? this.props.moment || this.props.presentMoment
                        : undefined
                    }
                    onCopyToMoment={
                      !!value?.id ? this.copySelectionToMoment : undefined
                    }
                    numberOfLines={!expanded ? 2 : numberOfLines}
                    // wrapperStyle={
                    //   !inline && {
                    //     minWidth: 900,
                    //     maxWidth: 900,
                    //     alignSelf: "center",
                    //     // borderWidth: 2,
                    //     borderColor: "red",
                    //   }
                    // }
                    focusNext={this.props.focusNext}
                    focusPrevious={this.props.focusPrevious}
                    onMetaUp={(e) => {
                      this.props.onMetaUp && this.props.onMetaUp(e);
                      expandable &&
                        expanded &&
                        this.setState({ expanded: false });
                    }}
                    onMetaDown={(e) => {
                      this.props.onMetaDown && this.props.onMetaDown(e);
                      expandable &&
                        !expanded &&
                        this.setState({ expanded: true });
                    }}
                    metaUpOnlyFromTop={this.props.metaUpOnlyFromTop}
                    onMetaCtrlRight={this.props.onMetaCtrlRight}
                    onMetaCtrlShiftRight={this.props.onMetaCtrlShiftRight}
                    onMetaEnter={this.handleMetaEnter}
                  />
                </View>
              ) : !editing ? (
                <TouchableWithoutFeedback
                  onPress={() => this.setState({ editing: true })}
                  style={{
                    cursor: "text",
                  }}
                >
                  <RichText
                    color={this.context.colors.foreground}
                    // selectionStart={selectionStart}
                    // selectionEnd={selectionEnd}
                    value={value}
                    // onPress={() => {
                    //   // alert("press");
                    //   this.setState({ editing: true });
                    // }}
                    // wrapperStyle={{
                    //   cursor: "text",
                    // }}
                  >
                    {text}
                  </RichText>
                </TouchableWithoutFeedback>
              ) : (
                <View>
                  <TextInput
                    value={text}
                    keyboardAccType={"scratchpad"}
                    multiline
                    autoHeight
                    autoFocus
                    inputRef={(r) => (this.input = r)}
                    onBlur={this.stopEditing}
                    style={{
                      lineHeight: this.context.sizes.default * 1.6,
                      minHeight: this.context.sizes.giant,
                      borderWidth: 10,
                    }}
                    onChangeText={(text) => {
                      this.setState({ text, isDirty: true });
                      this.handleChangeText();
                    }}
                    onMouseUp={() => {
                      this.applyQuery();
                    }}
                    onKeyPress={async (event) => {
                      let key = event.nativeEvent.key;
                      if (key == "Escape") {
                        this.stopEditing();
                      }
                      this.applyQuery();
                    }}
                  />
                </View>
              )}

              {this.renderFooter()}

              {expandable && !expanded && (
                <View
                  style={{
                    position: "absolute",
                    top: 1.5,
                    right: 0,
                    padding: this.context.sizes.tiny,
                    zIndex: 99,
                  }}
                >
                  <AntDesign
                    name={"down"}
                    size={this.context.sizes.default}
                    style={{
                      marginRight: this.context.sizes.base,
                      marginLeft: ENV.WEB ? 0 : this.context.sizes.base,
                      color: this.context.colors.trim,
                    }}
                    onPress={() => this.setState({ expanded: true })}
                  />
                </View>
              )}
            </View>
            {showJournalChat && (
              <JournalChatPanel
                currentText={text}
                currentTitle={value?.title}
                currentValueId={value?.id}
                onClose={() => this.setState({ showJournalChat: false })}
              />
            )}
          </View>
        )}
      </Hoverable>
    );
  }

  renderFooter = () => {
    let { value, chapter, inline } = this.props;
    let { text, editing, selection, query, isDirty } = this.state;
    if (editing) inline = false;
    if (!!chapter?.id) inline = true;
    let showActions = this.state.showActions;
    // if (inline) showActions = this.props.showActions;
    let Wrapper = ENV.WEB ? View : ScrollView;
    // showActions = true;
    return (
      <Wrapper horizontal showsHorizontalScrollIndicator={false}>
        {/*!!query?.length && (
          <View>
            <Autocomplete
              suggestionsOnly
              simpleListView
              // submitFirstOnPressEnter
              // onEnter={(value) => this.injectReference(value)}
              query={query}
              excludeIds={[value.id]}
              onSelectItem={(value) => {
                this.injectReference(value);
              }}
            />
            <Text
              button
              numberOfLines={1}
              onMouseDown={this.handleCreateFromQuery}
            >
              Create "{query.trim()}"
            </Text>
          </View>
        )*/}
        {!this.state.showJournalChat && (!showActions ? (
          <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: this.context.sizes.large }}>
            {!inline && (
              <TouchableOpacity
                onPress={() => this.setState({ showActions: true })}
                onMouseDown={(e) => ENV.WEB && e.preventDefault()}
              >
                <Feather
                  name={"more-horizontal"}
                  size={this.context.sizes.default}
                  style={{
                    marginRight: this.context.sizes.base,
                    color: this.context.colors.foreground,
                  }}
                />
              </TouchableOpacity>
            )}
            {this.state.editing && (
              <TouchableOpacity
                onPress={() => this.setState({ showJournalChat: true })}
                onMouseDown={(e) => ENV.WEB && e.preventDefault()}
              >
                <MaterialCommunityIcons
                  name="creation"
                  size={this.context.sizes.default}
                  style={{ color: this.context.colors.foreground }}
                />
              </TouchableOpacity>
            )}
          </View>
        ) : (
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: this.context.sizes.large,
            }}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {!inline && (
                <Feather
                  name={"x"}
                  size={this.context.sizes.default}
                  style={{
                    marginRight: this.context.sizes.base,
                    color: this.context.colors.foreground,
                  }}
                  // style={{ alignSelf: "flex-start" }}
                  // button
                  onPress={() => this.setState({ showActions: false })}
                />
              )}
              <MultiButton
                text="Suggestions"
                action={() => alert("suggestions")}
                options={[
                  {
                    text: "Suggest open sub-tasks",
                    action: () => alert("grandchildren"),
                  },
                  {
                    text: "What else?",
                    action: () => alert("other"),
                  },
                ]}
              />
              <Text
                button
                onPress={() => {
                  this.adoptReferences();
                }}
              >
                Adopt references
              </Text>
              <Text
                button
                onPress={() => {
                  this.clipboardToastAnim = new Animated.Value(1);
                  Animated.sequence([
                    // Animated.timing(this.clipboardToastAnim, {
                    //   toValue: 1,
                    //   duration: 200,
                    //   useNativeDriver: !ENV.WEB,
                    // }),
                    Animated.delay(1800),
                    Animated.timing(this.clipboardToastAnim, {
                      toValue: 0,
                      duration: 300,
                      useNativeDriver: !ENV.WEB,
                    }),
                  ]).start();
                  let text = `{${value.id}}`;
                  clipboardHelpers.copy(text);
                }}
              >
                <Feather name="link" size={this.context.sizes.default} />
              </Text>
              <Animated.View style={{ opacity: this.clipboardToastAnim }}>
                <Text>Copied to clipboard</Text>
              </Animated.View>
            </View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {isDirty && (
                <Text button onPress={this.discard}>
                  Discard Changes
                </Text>
              )}
              <MultiButton
                text={`Save ${!!selection ? "selection " : ""}as`}
                // action={this.convertNoteTo}
                options={[
                  ...(!!value?.id
                    ? [
                        {
                          text: "Save as moment",
                          action: this.saveAsMoment,
                        },
                        {
                          text: "Save full moment history",
                          action: this.saveFullMomentHistory,
                        },
                      ]
                    : []),
                  {
                    text: `Save ${!!selection ? "selection " : ""}as note`,
                    action: this.convertNoteTo,
                  },
                  {
                    text: `Duplicate ${!!selection ? "selection " : ""}as note`,
                    action: () => this.convertNoteTo("note", true),
                  },
                  {
                    text: `Save ${!!selection ? "selection " : ""}as sub-task`,
                    action: () => this.convertNoteTo("project"),
                  },
                  {
                    text: `Save ${!!selection ? "selection " : ""}as sibling`,
                    action: () => this.convertNoteTo("sibling"),
                  },
                  {
                    text: `Duplicate ${
                      !!selection ? "selection " : ""
                    }as sibling`,
                    action: () => this.convertNoteTo("sibling", true),
                  },
                ]}
              />
            </View>
          </View>
        ) : null)}
      </Wrapper>
    );
  };

  stopEditing = () => {
    if (this.updateTimeout) clearTimeout(this.updateTimeout);
    this.handleChangeText(0);
    this.setState({ editing: false });
  };

  // meta+enter from within the scratchpad opens the complete-value prompt for
  // this scratchpad's value (no-op for a value-less scratchpad, e.g. a chapter's).
  handleMetaEnter = async () => {
    let { value } = this.props;
    if (!value?.id) return;
    await valueActions.complete(value, null, true);
    this.props.onRefreshChapter && this.props.onRefreshChapter();
  };

  handleChangeText = async (delay = 1000) => {
    if (this.updateTimeout) clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(this.updateValue, delay);
  };

  updateValue = async () => {
    let { value, chapter, moment, autoCreateChapter } = this.props;
    let { text, updateValueTitle, knownUpdatedAt } = this.state;
    // Optimistically advance knownUpdatedAt before the request so that a
    // concurrent in-flight save doesn't share the same stale reference and
    // falsely trigger a conflict on a single device.
    const sendKnownUpdatedAt = knownUpdatedAt;
    this.setState({ knownUpdatedAt: new Date().toISOString() });
    let res;
    if (!!value?.id) {
      console.log("updating value");
      if (updateValueTitle)
        res = await valueActions.update(value.id, { title: text }, moment?.id, sendKnownUpdatedAt);
      else res = await valueActions.update(value.id, { text }, moment?.id, sendKnownUpdatedAt);
      if (res?.conflict) {
        // Another device saved newer content. Update our reference so the
        // next auto-save doesn't conflict, but do NOT touch the user's text.
        console.warn("ScratchPad: remote conflict detected, preserving local text");
        this.setState({ knownUpdatedAt: res.value.updated_at });
        return;
      } else if (res?.updated_at) {
        this.setState({ knownUpdatedAt: res.updated_at });
      }
    } else if (!!chapter?.id) {
      if (chapter.id == "auto") {
        this.autoCreateChapter();
        return;
      }
      res = await chapterActions.update(chapter.id, { text });
      if (res?.success) {
        this.props.onUpdateChapter && this.props.onUpdateChapter(res.chapter);
      }
    }
    if (!res) {
      console.warn("ScratchPad save failed");
    } else {
      this.props.onUpdateText && this.props.onUpdateText(text);
    }
  };

  autoCreateChapter = async () => {
    let { chapter, onUpdateChapter, parentChapter } = this.props;
    let { text } = this.state;
    let data = { text };
    if (!!chapter.start_at && !!chapter.end_at) {
      data.start_at = chapter.start_at;
      data.end_at = chapter.end_at;
    }
    let res = await chapterActions.create(data, parentChapter);
    if (!!res?.chapter && !!onUpdateChapter) {
      await onUpdateChapter(res.chapter);
    }
  };

  applyQuery = async () => {
    await new Promise((r) => setTimeout(r, 0));
    let { text } = this.state;
    let selection = null;
    let query = "";
    if (
      (!!this.input?.selectionStart || this.input?.selectionStart == 0) &&
      !!this.input?.selectionEnd &&
      this.input.selectionStart != this.input.selectionEnd
    ) {
      selection = [this.input.selectionStart, this.input.selectionEnd];
      query = text.slice(this.input.selectionStart, this.input.selectionEnd);
    } else {
      query = text.match(/#[^ \n\r#].*/);
      query = !!query ? query[0] : "#";
      query = query.slice(1);
    }
    console.log(query, selection);
    this.setState({ query, selection });
  };

  applySelection = async (selection = null) => {
    await new Promise((r) => setTimeout(r, 0));
    let { text } = this.state;
    text = text || "";
    let query = "";
    if (!!selection) {
      console.warn(selection);
      let line = text.split(/[\r\n]/)[selection[2]];
      query = line?.slice(selection[0], selection[1]) || "";
    } else {
      query = text.match(/#[^ \n\r#].*/);
      query = !!query ? query[0] : "#";
      query = query.slice(1);
    }
    // }
    // console.log(query, selection);
    this.setState({ query, selection });
  };

  handleCreateFromQuery = async () => {
    let { value } = this.props;
    let { query } = this.state;
    let child = await valueActions.create({
      text: query.trim(),
      parent_ids: [value.id],
    });
    if (!!child?.id) {
      this.injectReference(child);
      this.setState({ query: "" });
    }
  };

  injectReference = async (refVal) => {
    let { text, selection, query } = this.state;

    if (!!selection) {
      text = text
        .split(/[\r\n]/)
        .map((line, i) => {
          if (i == selection[2]) {
            return `${line.slice(0, selection[0])}${refVal.id}${line.slice(
              selection[1],
            )}`;
          } else return line;
        })
        .join("\n");
    } else if (!!query) {
      text = text.replace(/#[^ \n\r#].*/, `{${refVal.id}}`);
    }
    await this.setState({ text, query: "", selection: null });
    this.handleChangeText(0);
  };

  // Moves the entire scratchpad into a moment's body: the moment being
  // viewed if there is one, otherwise a new moment pinned to today. The
  // value's own text is cleared afterwards.
  saveAsMoment = async () => {
    let { value } = this.props;
    // presentMoment: today's day-moment supplied by views that aren't
    // themselves scoped to a moment (e.g. the value dash)
    let moment = this.props.moment || this.props.presentMoment;
    let { text } = this.state;
    if (!value?.id || !text?.trim()?.length) return;
    // cancel any pending auto-save so it can't re-write the old text
    if (this.updateTimeout) clearTimeout(this.updateTimeout);

    if (!!moment?.id) {
      let existing = moment.text?.trim();
      let newText = !!existing?.length ? `${existing}\n${text}` : text;
      let res = await momentActions.update(moment.id, { text: newText });
      if (!res?.success) {
        alert("Could not save to the moment — scratchpad left untouched");
        return;
      }
    } else {
      // create the moment before clearing so its snapshot preserves the
      // value state that produced this text
      let created = await momentActions.create({
        value_id: value.id,
        value_ids: [value.id],
        text,
        chapter_id: "today",
      });
      if (!created) {
        alert("Could not create the moment — scratchpad left untouched");
        return;
      }
    }

    await this.setState({ text: "", isDirty: false });
    let updated = await valueActions.update(value.id, { text: "" }, moment?.id);
    if (updated?.updated_at) {
      this.setState({ knownUpdatedAt: updated.updated_at });
    }
    this.props.onUpdateText && this.props.onUpdateText("");
    this.props.onRefreshChapter && this.props.onRefreshChapter();
  };

  // Copies the given text into a moment: the moment being viewed if there
  // is one, otherwise a new moment pinned to today. The scratchpad text is
  // left untouched.
  copySelectionToMoment = async (selectedText) => {
    let { value } = this.props;
    let moment = this.props.moment || this.props.presentMoment;
    if (!value?.id || !selectedText?.trim()?.length) return false;

    if (!!moment?.id) {
      let existing = moment.text?.trim();
      let newText = !!existing?.length
        ? `${existing}\n${selectedText}`
        : selectedText;
      let res = await momentActions.update(moment.id, { text: newText });
      if (!res?.success) {
        alert("Could not copy to the moment");
        return false;
      }
    } else {
      let created = await momentActions.create({
        value_id: value.id,
        value_ids: [value.id],
        text: selectedText,
        chapter_id: "today",
      });
      if (!created) {
        alert("Could not create the moment");
        return false;
      }
    }
    this.props.onRefreshChapter && this.props.onRefreshChapter();
    return true;
  };

  // Distributes the scratchpad's accumulated history across all of the
  // value's moments via snapshot diffs (server-side). Leaves the scratchpad
  // text untouched.
  saveFullMomentHistory = async () => {
    let { value } = this.props;
    if (!value?.id) return;
    if (this.state.savingHistory) return;
    this.setState({ savingHistory: true });
    let res = await valueActions.saveMomentHistory(value.id);
    this.setState({ savingHistory: false });
    if (!res?.success) {
      alert("Failed to save moment history");
      return;
    }
    alert("Moment history saved");
    this.props.onRefreshChapter && this.props.onRefreshChapter();
  };

  convertNoteTo = async (type = "note", duplicate = false) => {
    let { value, moment } = this.props;
    let { text, selection } = this.state;
    if (!!selection) {
      text = text.slice(selection[0], selection[1]);
    }
    if (type == "sibling") {
      text = `# Created as sibling of {${value.id}|${value.id}}\n` + text;
    }

    let title = text.split(/[\r\n]/)[0].replace(/^#{3} /, "");
    let child = await valueActions.create({
      title,
      text,
      parent_ids: type == "sibling" ? value.parent_ids : [value.id],
      is_note: type == "note",
    });
    if (!!selection) {
      this.setState({ selection: null, query: "" });
    } else if (!!child && !duplicate) {
      this.setState({ text: "" });
      valueActions.update(value.id, { text: "" }, moment?.id);
    }
  };

  adoptReferences = async () => {
    let { value } = this.props;
    let { text } = this.state;
    let references = richTextHelpers.getReferences(text);
    alert(references);
  };

  discard = async () => {
    let { initialText } = this.state;
    await this.setState({ text: initialText });
    this.handleChangeText(0);
    this.setState({ editing: false });
  };

  styles = () => {
    return {
      wrapper: {
        borderWidth: 1,
        borderColor: this.context.colors.trim,
        borderRadius: this.context.sizes.borderRadius,
        padding: this.context.sizes.large,
      },
      inlineWrapper: {
        borderWidth: 0,
        padding: 0,
      },
    };
  };
}
